<div class="detail-container">
  <nb-card [nbSpinner]="!!(loading$|async)">
    <nb-card-header>
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5>Sensorblock</h5>
      @if (canEdit()) {
        <wr-edit-delete-button-group [canDelete]="canDelete" (edit)="onEdit()" (delete)="onDeleteSensorBlock()">
        </wr-edit-delete-button-group>
      }
    </nb-card-header>
    <nb-card-body>
      @if (form) {
        <nb-tabset>
          <nb-tab tabTitle="Daten">
            <hau-form [formGroup]="form">
              <div class="top-fields-grid">
                <hau-form-field label="Name" [validation]="form.validation.name" cols="12">
                  <input nbInput fullWidth formControlName="name">
                </hau-form-field>
                <hau-form-field label="Farbe" [validation]="form.validation.color" cols="12">
                  <wr-color-preset-picker formControlName="color"></wr-color-preset-picker>
                </hau-form-field>
                <hau-form-field label="Steuerungssystem-ID" [validation]="form.validation.controlSystemId" cols="12">
                  @if (controlSystemOptions().length > 0) {
                    <nb-select fullWidth formControlName="controlSystemId" placeholder="Vom Gebäude erben">
                      <nb-option value="">Vom Gebäude erben</nb-option>
                      @for (controlSystem of controlSystemOptions(); track controlSystem.id) {
                        <nb-option [value]="controlSystem.id">{{ controlSystem.name }}</nb-option>
                      }
                    </nb-select>
                  } @else {
                    <input nbInput fullWidth formControlName="controlSystemId">
                  }
                </hau-form-field>
              </div>
              <hau-form-field label="Beschreibung" [validation]="form.validation.description" cols="12">
                <textarea nbInput fullWidth formControlName="description"></textarea>
              </hau-form-field>
              <section class="sensors-section">
                <div class="section-header">
                  <h6 class="section-title">Sensoren</h6>
                  @if (isEditing) {
                    <button class="add-sensor-button" (click)="createNewSensor()" nbButton status="primary" size="small">
                      <nb-icon pack="eva" icon="plus-outline"></nb-icon>
                      Sensor hinzufügen
                    </button>
                  }
                </div>
                <div class="sensor-list-form">
                <div class="sensor-list-column">
                  @if (form.controls.sensors.controls.length > 0) {
                    <nb-list class="sensor-list">
                      @for (sensor of form.controls.sensors.controls; track sensor.get('localId')?.value; let
                        i = $index) {
                        <nb-list-item
                          class="sensor-list-item"
                          (click)="selectedIndex.set(i)"
                          [class.active]="selectedIndex() === i">
                          <div>
                            <span class="dot"
                                  [style.background]="sensor.get('color')?.value"></span>
                            <span class="sensor-name">{{ sensor.get('name')?.value || 'Neuer Sensor' }}</span>
                          </div>
                          <button nbButton ghost status="danger" (click)="$event.stopPropagation(); onDeleteSensor($index)" [disabled]="!isEditing">
                            <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
                          </button>
                        </nb-list-item>
                      }
                    </nb-list>
                  } @else {
                    <div class="no-sensors">Keine Sensoren</div>
                  }
                </div>
                @let selectedSensor = form.controls.sensors.controls[selectedIndex()];
                @if (selectedSensor) {
                  <hau-form-group [formGroup]="selectedSensor">
                    <hau-form-field hidden label="Id" cols="0">
                      <input nbInput fullWidth formControlName="id" readonly>
                    </hau-form-field>
                    <div class="sensor-top-grid">
                      <div class="name-toggles-row">
                        <hau-form-field label="Name" [validation]="selectedSensor.validation.name"
                                        cols="12">
                          <input nbInput fullWidth formControlName="name">
                        </hau-form-field>
                        <hau-form-field label="Aktiv"
                                        [validation]="selectedSensor.validation.isActive" cols="12">
                          <nb-toggle formControlName="isActive"></nb-toggle>
                        </hau-form-field>
                        @if (selectedSensor.get('purpose')?.value === monitoringPurpose) {
                          <hau-form-field label="Sichtbar"
                                          [validation]="selectedSensor.validation.isVisible" cols="12">
                            <nb-toggle formControlName="isVisible"></nb-toggle>
                          </hau-form-field>
                        }
                      </div>
                      <hau-form-field label="Funktionsblock-ID"
                                      [validation]="selectedSensor.validation.functionBlockId"
                                      cols="12">
                        <input nbInput fullWidth formControlName="functionBlockId" type="text"
                               placeholder="Funktionsblock-ID">
                      </hau-form-field>
                    </div>
                    <hau-form-field label="Farbe" [validation]="selectedSensor.validation.color"
                                    cols="12">
                      <wr-color-preset-picker
                        formControlName="color"></wr-color-preset-picker>
                    </hau-form-field>
                    <hau-form-field label="Einheit & Label"
                                    [validation]="selectedSensor.validation.sensorUnitLabel"
                                    cols="12">
                      <wr-sensor-unit-label-select
                        formControlName="sensorUnitLabel"></wr-sensor-unit-label-select>
                    </hau-form-field>
                    <hau-form-field label="Anzeige-Einheit" cols="6">
                      <nb-icon hauSuffix
                               class="info-hint-icon"
                               icon="info-outline"
                               pack="eva"
                               nbTooltip="Optional. Rohdaten bleiben in der Sensor-Einheit; die Anzeige wird umgerechnet."
                               nbTooltipPlacement="top">
                      </nb-icon>
                      <wr-sensor-unit-select
                        formControlName="displayUnit"
                        [showEmptyOption]="true"
                        [compatibleWith]="selectedSensor.get('sensorUnitLabel')?.value?.sensorUnit ?? null">
                      </wr-sensor-unit-select>
                    </hau-form-field>
                    <hau-form-field label="Metrik Typ"
                                    [validation]="selectedSensor.validation.sensorMetricKind"
                                    cols="6">
                      <wr-sensor-metric-kind-select
                        formControlName="sensorMetricKind"></wr-sensor-metric-kind-select>
                    </hau-form-field>
                    <hau-form-field label="Verwendung"
                                    [validation]="selectedSensor.validation.purpose"
                                    cols="6">
                      <nb-icon hauSuffix
                               class="info-hint-icon"
                               icon="info-outline"
                               pack="eva"
                               nbTooltip="Wurzelzähler fließen in die EOC-Bilanzen, Wohnungszähler in die Wohnungsabrechnung, Anlagenstatus-Sensoren (z. B. Temperaturen) in den Anlagenstatus."
                               nbTooltipPlacement="top">
                      </nb-icon>
                      <wr-sensor-purpose-select
                        formControlName="purpose"></wr-sensor-purpose-select>
                    </hau-form-field>
                    <hau-form-field label="Funktionsblock-Adresse"
                                    [validation]="selectedSensor.validation.fbAddress" cols="6">
                      <input nbInput fullWidth formControlName="fbAddress" type="text" inputmode="numeric"
                             maxlength="4"
                             placeholder="z. B. 31">
                    </hau-form-field>
                    <hau-form-field label="Datenpunkt (ConId)"
                                    [validation]="selectedSensor.validation.connectorId" cols="6">
                      <nb-icon hauSuffix
                               class="info-hint-icon"
                               icon="info-outline"
                               pack="eva"
                               nbTooltip="Wird beim ersten Sync automatisch aus der Reisenbauer-Konfiguration ermittelt (periodisch aufgezeichneter Datenpunkt der Adresse). Nur setzen, wenn der Sensor wegen mehrerer Datenpunkte an der Adresse gesperrt ist oder der Sync SENSOR_SYNC_NO_CONID bzw. SENSOR_SYNC_CONID_COLLISION meldet. Eine Änderung löst einen vollständigen Neu-Import aus."
                               nbTooltipPlacement="top">
                      </nb-icon>
                      <input nbInput fullWidth formControlName="connectorId" type="text" inputmode="numeric"
                             maxlength="3"
                             placeholder="automatisch">
                    </hau-form-field>
                    @if (selectedSensor.get('sensorMetricKind')?.value === cumulativeMetricKind) {
                      <hau-form-field label="Abgelesener Zählerstand" cols="6">
                        <nb-icon hauSuffix
                                 class="info-hint-icon"
                                 icon="info-outline"
                                 pack="eva"
                                 nbTooltip="Für Zähler, die in Serie zu einem fremden Zähler sitzen: der abgelesene Stand des Fremdzählers wird zum Ausgangspunkt, der gemessene Zuwachs wird daraufaddiert. Eingabe in der gewählten Anzeige-Einheit; die Korrektur gilt rückwirkend für die gesamte Messhistorie, Verbrauchszahlen bleiben unverändert. Wert oder Zeitpunkt leeren entfernt die Korrektur."
                                 nbTooltipPlacement="top">
                        </nb-icon>
                        <input nbInput fullWidth formControlName="anchorValue" type="number" step="any" min="0"
                               placeholder="z. B. 1234.5">
                      </hau-form-field>
                      <hau-form-field label="Ablesezeitpunkt" cols="6">
                        <nb-icon hauSuffix
                                 class="info-hint-icon"
                                 icon="info-outline"
                                 pack="eva"
                                 nbTooltip="Zeitpunkt der Ablesung am Fremdzähler. Zu diesem Zeitpunkt müssen bereits Messdaten vorliegen."
                                 nbTooltipPlacement="top">
                        </nb-icon>
                        <input nbInput fullWidth formControlName="anchorTimestamp"
                               placeholder="Datum und Uhrzeit wählen"
                               [nbDatepicker]="anchorTimestampPicker"/>
                        <nb-date-timepicker #anchorTimestampPicker></nb-date-timepicker>
                      </hau-form-field>
                    }
                    <hau-form-field label="Beschreibung"
                                    [validation]="selectedSensor.validation.description"
                                    cols="12">
                      <textarea nbInput fullWidth formControlName="description"></textarea>
                    </hau-form-field>
                  </hau-form-group>
                }
                </div>
              </section>
            </hau-form>
          </nb-tab>
          @if (!isNew()) {
            <nb-tab tabTitle="Diagramm">
              <ng-template nbTabContent>
                <wr-sensor-block-chart-view [embedded]="true"></wr-sensor-block-chart-view>
              </ng-template>
            </nb-tab>
          }
        </nb-tabset>
      }
    </nb-card-body>
    @if (canEdit() || isNew()) {
      <nb-card-footer>
        <button size="medium" [disabled]="!isEditing" nbButton status="primary" (click)="submit()">Speichern</button>
        <button size="medium" [disabled]="!isEditing" nbButton status="basic" (click)="cancel()">Zurück</button>
      </nb-card-footer>
    }
  </nb-card>
</div>
